import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidacionesService {

  constructor() { }

  checkCif(cif:any){
    
  let DNI_REGEX = /^(\d{8})([A-Z])$/;
  let CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
  
  cif = cif?.toUpperCase();
  if ( cif?.match( DNI_REGEX ) ) {
  let numero, lett, letra;
  let expresion_regular_dni = /^[XYZ]?\d{5,8}[A-Z]$/;
 
	if(expresion_regular_dni.test(cif) === true){
		numero = cif.substr(0,cif.length-1);
		numero = numero.replace('X', 0);
		numero = numero.replace('Y', 1);
		numero = numero.replace('Z', 2);
		lett = cif.substr(cif.length-1, 1);
		numero = numero % 23;
		letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
		letra = letra.substring(numero, numero+1);
		if (letra != lett) {
			//Dni erroneo, la letra del NIF no se corresponde
			return false;
		}else{
			//Dni correcto
			return true;
		}
	}else{
		//Dni erroneo, formato no válido
		return false;
	}
  
  }
  else if ( cif?.match( CIF_REGEX )) {
  
  let temp = cif
  if (!/^[A-Za-z0-9]{9}$/.test(temp)){
    return false
  }  else if (!/^[ABCDEFGHKLMNPQS]/.test(temp)){
    return false

  } 
  else{
    return true;
  } 

  }else{
    return false
  }

}


}
